import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { PermissionsService } from '../../../services/permissions.service';
import { ModuleLocatiiActiveService } from 'src/app/platform/nomenclatoare/module-locatii-active/module-locatii-active.service';
import { finalize } from 'rxjs';
import { Generic, GenericLocatieActiva } from 'src/app/interfaces/generic.interface';
import { ModuleService } from 'src/app/platform/nomenclatoare/module/module.service';
import { SidenavService } from 'src/app/services/sidenav.service';

@Component({
    selector: 'sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
    isCollapsed = false;
    panelOpenState = false;
    appName = environment.config.appName;
    appDescription = environment.config.appDescription;
    activeOption = '';
    modules: Generic[] = [];
    locatiiActive: GenericLocatieActiva[] = [];

    isLoading = false;

    // modulesRoutes = [
    //     {
    //         id: 3,
    //         name: 'Programări acte de identitate',
    //         icon: 'icon-id.svg',
    //     },
    //     {
    //         id: 4,
    //         name: 'Programări căsătorii',
    //         icon: 'icon-casatorie.svg',
    //     },
    //     {
    //         id: 5,
    //         name: 'Programări transcrieri',
    //         icon: 'icon-translate.svg',
    //     },
    //     {
    //         id: 6,
    //         name: 'Programări stabilirea reședinței',
    //         icon: 'icon-home.svg',
    //     },
    // ]

    constructor(
        public permissionsService: PermissionsService,
        private router: Router,
        private storageService: StorageService,
        public sidenavService: SidenavService,
    ) {
        this.activeOption = router.url;
        this.onResize();
    }

    setActive(value: string) {
        this.activeOption = value;
    }

    logout() {
        this.storageService.clear();
        window.location.href = environment.interop.authCore.linkRedirectAuth;
    }

    redirectToinDeskPlatform() {
        window.location.href = environment.interop.authCore.linkRedirectAuth;
    }

    toggleSidebar() {
        this.isCollapsed = !this.isCollapsed;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isCollapsed = window.innerWidth < 960;
    }

    navigateToProgramariView(moduleId: number, locatieActivaId: number,) {
        // this.setActive('/programari-view/' + locatieActivaId);
        this.setActive('/settings');

        this.router.navigate(['/programari-view'], { queryParams: { moduleId: moduleId, locatieActivaId: locatieActivaId } });
    }
}
